<template>
  <v-app id="vuetify-app">
    <v-container>
      <v-flex xs12>
        <v-tabs fixed-tabs v-model="activeTab">
          <v-tab v-for="type in availableTypes" :key="type.value" :href="`#${type.value}`">
            {{ type.label }}
          </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex xs12>
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="type in availableTypes" :value="type.value" :key="type.value">
            <education-list
              :education-list="education.filter(e => e.type === type.value)"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-container>
  </v-app>
</template>

<script>
import { availableTypes as availableTypesLibs } from '../administrator/education/libs';
import { mapActions, mapGetters } from 'vuex';

export default {
  data: function () {
    return {
      availableTypes: availableTypesLibs(),
      activeTab: null,
    };
  },
  computed: {
    ...mapGetters(['education']),
  },
  methods: {
    ...mapActions(['fetchEducation']),
  },
  created() {
    this.fetchEducation();
  },
};
</script>

<style scoped></style>
